import React from 'react';
import { Chip, Stack } from '@mui/material';
import { SelectChipFromArray } from '../functions/SelectChipFromArray';
import { DeleteMultiSelectValues } from '../functions/DeleteMultiSelectValues';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
const ChipMultiSelect = ({
  selected,
  UiValue,
  SelectableDataArray,
  setUiValue,
  isEnglish,
}) => {
  const Result = SelectChipFromArray(
    UiValue,
    SelectableDataArray
  );
  const handleDelete = DeleteMultiSelectValues(setUiValue);
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      dir={!isEnglish ? 'rtl' : 'ltr'}
    >
      {selected.map((value, index) => (
        <div key={value} sx={{ display: 'inline-flex' }}>
          <Chip
            onMouseDown={(event) => event.stopPropagation()}
            label={ArabicToPersian(Result[index])}
            onDelete={(event) => {
              handleDelete(index);
            }}
            sx={{
              m: 0.5,
              flexDirection: 'row-reverse',
              border: `1px solid ${themeColors.ColorPrimary}`,
            }}
            color={'colorSecondary'}
          />
        </div>
      ))}
    </Stack>
  );
};

export default ChipMultiSelect;
